/*=========================================================================================
  File Name: moduleMessagerieState.js
  Description: Messagerie Module State
==========================================================================================*/

export default {
  conversations: [],
  activeConversationId: null,
  messages: [],
  unread: { totalUnread: 0, unreadConversations: 0 },
  // null = not loaded yet ; 0 = no client has a MonPatrimoine account (=> show "invite a client").
  contactableClientsCount: null,
  isLoading: false,
  isSending: false,
  pollTimer: null,
};
